export default __webpack_public_path__ + "static/media/logo-05 1.d8931c04.jpg";